import { render, staticRenderFns } from "./beechOriginalExcel.vue?vue&type=template&id=c2e2ee2e&scoped=true&"
import script from "./beechOriginalExcel.vue?vue&type=script&lang=js&"
export * from "./beechOriginalExcel.vue?vue&type=script&lang=js&"
import style0 from "./beechOriginalExcel.vue?vue&type=style&index=0&id=c2e2ee2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e2ee2e",
  null
  
)

export default component.exports